import fetchWPPageContent from '../../api/fetchWPPageContent';

const getPath = (lang) => {
  const path =
    lang === 'de'
      ? 'de/wp-json/wp/v2/pages?slug=impressum'
      : 'wp-json/wp/v2/pages?slug=imprint';

  return path;
};

const fetchData = async ({ lang }) => {
  const path = getPath(lang);
  return fetchWPPageContent(path);
};

export default fetchData;
